export default __webpack_public_path__ + "static/media/theme1.ea588735.png";